import { render, staticRenderFns } from "./SuppliesList.vue?vue&type=template&id=49bdc6ea&"
import script from "./SuppliesList.ts?vue&type=script&lang=js&"
export * from "./SuppliesList.ts?vue&type=script&lang=js&"
import style0 from "./SuppliesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports